<div class="create-product-container">
  <div class="create-product-header">
    <h2 class="create-product-title">
      <i class="pi pi-plus-circle"></i>
      Create New Product
    </h2>
    <p class="create-product-subtitle">
      Add a new product to the clinic inventory
    </p>
  </div>

  <form [formGroup]="productForm" (ngSubmit)="onSubmit()" class="create-product-form">
    <div class="form-grid">
      <!-- Basic Information Section -->
      <div class="form-section">
        <h3 class="section-title">
          <i class="pi pi-info-circle"></i>
          Basic Information
        </h3>
        
        <div class="form-field">
          <label class="form-label">
            <i class="pi pi-tag"></i>
            Stock Item Code
          </label>
          <input 
            type="text" 
            formControlName="stock_item_code" 
            class="modern-input"
            placeholder="Enter stock item code"
            [class.input-error]="productForm.get('stock_item_code')?.invalid && productForm.get('stock_item_code')?.touched"
          />
          <div class="error-message" *ngIf="productForm.get('stock_item_code')?.invalid && productForm.get('stock_item_code')?.touched">
            Stock item code is required and must be at least 3 characters
          </div>
        </div>

        <div class="form-field">
            <label class="form-label">
                <i class="pi pi-barcode"></i>
                Product ID
            </label>
            <input 
                type="text" 
                formControlName="product_id" 
                class="modern-input"
                placeholder="Enter product ID"
                [class.input-error]="productForm.get('product_id')?.invalid && productForm.get('product_id')?.touched"
            />
            <div class="error-message" *ngIf="productForm.get('product_id')?.invalid && productForm.get('product_id')?.touched">
                Product ID is required and must be at least 3 characters
            </div>
            
        </div>

        <div class="form-field">
          <label class="form-label">
            <i class="pi pi-ruler"></i>
            Size
          </label>
          <input 
            type="text" 
            formControlName="size" 
            class="modern-input"
            placeholder="Enter product size"
            [class.input-error]="productForm.get('size')?.invalid && productForm.get('size')?.touched"
          />
          <div class="error-message" *ngIf="productForm.get('size')?.invalid && productForm.get('size')?.touched">
            Size is required and must be at least 1 character
          </div>
        </div>

        <div class="form-field">
          <label class="form-label">
            <i class="pi pi-file-text"></i>
            Description
          </label>
          <textarea 
            formControlName="description" 
            class="modern-textarea"
            placeholder="Enter product description"
            rows="3"
            [class.input-error]="productForm.get('description')?.invalid && productForm.get('description')?.touched"
          ></textarea>
          <div class="error-message" *ngIf="productForm.get('description')?.invalid && productForm.get('description')?.touched">
            Description is required and must be at least 5 characters
          </div>
        </div>
      </div>

      <!-- Pricing & Inventory Section -->
      <div class="form-section">
        <h3 class="section-title">
          <i class="pi pi-dollar"></i>
          Pricing & Inventory
        </h3>
        
        <div class="form-field">
          <label class="form-label">
            <i class="pi pi-box"></i>
            Quantity
          </label>
          <input 
            type="number" 
            formControlName="quantity" 
            class="modern-input"
            placeholder="Enter quantity"
            min="1"
            [class.input-error]="productForm.get('quantity')?.invalid && productForm.get('quantity')?.touched"
          />
          <div class="error-message" *ngIf="productForm.get('quantity')?.invalid && productForm.get('quantity')?.touched">
            Quantity must be at least 1
          </div>
        </div>

        <div class="form-field">
          <label class="form-label">
            <i class="pi pi-calculator"></i>
            Cost Excl. VAT
          </label>
          <input 
            type="number" 
            formControlName="cost_excl_vat" 
            step="0.01" 
            class="modern-input"
            placeholder="Enter cost excluding VAT"
            min="0.01"
            [class.input-error]="productForm.get('cost_excl_vat')?.invalid && productForm.get('cost_excl_vat')?.touched"
          />
          <div class="error-message" *ngIf="productForm.get('cost_excl_vat')?.invalid && productForm.get('cost_excl_vat')?.touched">
            Cost must be at least R0.01
          </div>
        </div>

        <div class="form-field">
          <label class="form-label">
            <i class="pi pi-calculator"></i>
            Cost Incl. VAT
          </label>
          <input 
            type="number" 
            formControlName="cost_incl_vat" 
            step="0.01" 
            class="modern-input"
            placeholder="Enter cost including VAT"
            min="0.01"
            [class.input-error]="productForm.get('cost_incl_vat')?.invalid && productForm.get('cost_incl_vat')?.touched"
          />
          <div class="error-message" *ngIf="productForm.get('cost_incl_vat')?.invalid && productForm.get('cost_incl_vat')?.touched">
            Cost must be at least R0.01
          </div>
        </div>
      </div>

    </div>

    <!-- Additional Settings Section - Full Width -->
    <div class="form-section full-width">
      <h3 class="section-title">
        <i class="pi pi-cog"></i>
        Additional Settings
      </h3>
      
      <div class="settings-grid">
        <div class="form-field">
          <label class="form-label">
            <i class="pi pi-power-off"></i>
            Product Status
          </label>
          <div class="checkbox-field">
            <input 
              type="checkbox" 
              formControlName="is_active" 

              id="is_active"
            />
            <label for="is_active" class="checkbox-label">
              <span class="checkbox-text">Active Product</span>
            </label>
          </div>
        </div>

        <div class="form-field">
          <label class="form-label">
            <i class="pi pi-image"></i>
            Product Image
          </label>
          <div class="file-upload-field">
            <input 
              type="file" 
              (change)="onFileSelected($event)" 
              class="modern-file-input"
              accept="image/*"
              id="product_image"
            />
            <label for="product_image" class="file-upload-label">
              <i class="pi pi-upload"></i>
              <span>{{ selectedFile ? selectedFile.name : 'Choose an image file' }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="form-actions">
      <button 
        type="submit" 
        [disabled]="productForm.invalid || isSubmitting"
        class="modern-button primary"
      >
        <i class="pi pi-check" *ngIf="!isSubmitting"></i>
        <i class="pi pi-spinner pi-spin" *ngIf="isSubmitting"></i>
        {{ isSubmitting ? 'Creating Product...' : 'Create Product' }}
      </button>
    </div>
  </form>
</div>